import { render, staticRenderFns } from "./MultivalueEditor.vue?vue&type=template&id=7fc8d002&"
import script from "./MultivalueEditor.vue?vue&type=script&lang=ts&"
export * from "./MultivalueEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports